// Google AdSense settings
// Publisher: pub-3607032802245945
// Auto ads: AdSense 콘솔에서 사이트에 대해 Auto ads를 켜면 스크립트만으로도 광고가 노출됩니다.
// 수동 슬롯: Ads → By ad unit에서 단위 생성 후 아래 slot 번호를 넣으세요.

const ADSENSE_CLIENT = 'ca-pub-3607032802245945';

const ADSENSE_SLOTS = {
    // AdSense에서 광고 단위 생성 후 숫자 slot ID로 교체
    belowTitle: '',
    aboveFooter: ''
};

function isConfiguredClient(client) {
    return Boolean(client) && client.startsWith('ca-pub-') && !client.includes('XXXXXXXX');
}

function isConfiguredSlot(slot) {
    return Boolean(slot) && /^\d+$/.test(String(slot));
}

export const adsenseConfig = {
    enabled: isConfiguredClient(ADSENSE_CLIENT),
    client: ADSENSE_CLIENT,
    slots: ADSENSE_SLOTS,
    isSlotReady(slotKey) {
        return this.enabled && isConfiguredSlot(this.slots[slotKey]);
    }
};

export default adsenseConfig;



// WEBPACK FOOTER //
// ./src/config/adsense.js